"use strict";

function LabelService(DOM) {
	var schema = {} ;
	var section_schema = {};
	var remoteOptions = {} ;
	var globals = {} ;
	var genericValidationMessages = {} ;
	var content = {} ;
	var campaigns = {} ;

	DOM.addEventListener('register-labels', function (e) {
		registerLabels(DOM);
	}, false);

	function registerLabels(conf) {
		schema = conf.qbe.fieldLabels;
		section_schema = conf.qbe.sectionLabels;
		genericValidationMessages = conf.qbe.validationMessages ;
		content = conf.qbe.content;
		campaigns = conf.qbe.campaigns;
		globals = conf.globals;
	}

	function extractLabelsFor(fieldName) {
		var field = schema[fieldName] ;
		if ( ! field ) {
			return '' ;
			// throw fieldName + ' does not exist in the form schema';
		}

		return schema[fieldName] ;
	}

	function extractSectionLabelsFor(fieldName) {
		var field = section_schema[fieldName] ;
		if ( ! field ) {
			return '' ;
			// throw fieldName + ' does not exist in the form schema';
		}

		return section_schema[fieldName] ;
	}

	function extractContentLabelsFor(fieldName) {
		var field = content[fieldName] ;
		if ( ! field ) {
			return '' ;
			// throw fieldName + ' does not exist in the form schema';
		}

		return content[fieldName] ;
	}

	function extractCampaignInfoFor(campaignId) {
		return function findCampaignById(campaigns) {
			var campaign;
			angular.forEach(campaigns, function(c){
				if ( c.sc_camp == campaignId){
					return campaign = c ; 	
				}
			});
			return campaign;
		}(campaigns) ;
	}

	function getObjectValue(fieldName, fieldLabel) { 
		return extractLabelsFor(fieldName)[fieldLabel] ;
	}

	function getLabelFor(fieldName) {
		return extractLabelsFor(fieldName)['label'] ;
	}

	function getSectionLabelFor(fieldName) {
		return extractSectionLabelsFor(fieldName)['sectionHeadingText'] ;
	}

	function getSectionDescriptionFor(fieldName) {
		return extractSectionLabelsFor(fieldName)['sectionDescriptionText'] ;
	}

	function getHintTextFor(fieldName) {
		return extractLabelsFor(fieldName)['hintText'] ;
	}

	function getHelpTextFor(fieldName) {
		return extractLabelsFor(fieldName)['extendedHintText'] ;
	}

	function getTooltipFor(fieldName) {
		return extractLabelsFor(fieldName)['tooltip'] ;
	}

	function getSecondaryInfoTextFor(fieldName){
		return extractLabelsFor(fieldName)['secondaryInfoText'];
	}

	function getValidationMessagesFor(fieldName, rule) {
		var validations = extractLabelsFor(fieldName)['validationMessages'] ;
		if ( ! validations || ! validations[rule] )
			return getGenericValidationMessageFor(rule) ;

		return validations[rule];
	}

	function getGenericValidationMessageFor(rule) {
		return genericValidationMessages[rule] ;
	}

	function getOptionsFor(fieldName) {
		return schema[fieldName].options;
	}

	function getGlobalOptionsFor(fieldName) {
		return globals[fieldName].options;
	}

	function getLabelForRemoteOption(fieldName, option) {
		//return schema[fieldName].remoteOptions[options];
		var arr = schema[fieldName].remoteOptions;
		var obj = arr.filter(function ( obj ) {
			return obj.key === option;
		})[0];
		return obj;
	}

	function getSecondaryInfoTextFlag(fieldName){
		return Boolean(schema[fieldName]['secondaryInfoTextDisplayOn']);
	}


	function getContent(fieldName) {
		return extractContentLabelsFor(fieldName);
	}

	function getGlobalOptionLabel(optionType, optionValue) {
		var optionKeyValues = this.getGlobalOptionsFor(optionType) ;
		var label = null;
		if ( optionKeyValues ) {
			angular.forEach(optionKeyValues, function(option){
				if ( option.value == optionValue )
					label = option.label ;
			})
		}

		return label;
	}
	function getGlobalOption(optionType, optionValue) {
		var optionKeyValues = this.getGlobalOptionsFor(optionType) ;
		var returnOption = null;
		if ( optionKeyValues ) {
			angular.forEach(optionKeyValues, function(option){
				if ( option.value === optionValue )
					returnOption = option ;
			});
		}
		return returnOption;
	}

	return {
		init:registerLabels,
		getObjectValue: getObjectValue,
		getLabelFor: getLabelFor,
		getSectionLabelFor: getSectionLabelFor,
		getSectionDescriptionFor: getSectionDescriptionFor,
		getHintTextFor: getHintTextFor,
		getHelpTextFor: getHelpTextFor,
		getTooltipFor: getTooltipFor,
		getValidationMessagesFor: getValidationMessagesFor,
		getGenericValidationMessageFor: getGenericValidationMessageFor,
		getOptionsFor: getOptionsFor,
		getGlobalOptionsFor: getGlobalOptionsFor,
		getLabelForRemoteOption: getLabelForRemoteOption,
		getContent: getContent,
		extractCampaignInfoFor: extractCampaignInfoFor,
		getSecondaryInfoTextFor: getSecondaryInfoTextFor,
		getSecondaryInfoTextFlag: getSecondaryInfoTextFlag,
		getGlobalOptionLabel: getGlobalOptionLabel,
		getGlobalOption: getGlobalOption
	};
}
